import { Accordion, type AccordionProps } from '@chakra-ui/react'
import React from 'react'


const Component = React.forwardRef((props: AccordionProps, ref: React.Ref<any>) => {
  return <Accordion ref={ref} allowMultiple { ...props } />
})


export {
  Component as Accordion,
  type AccordionProps,
}